import axios from "axios";
import { Toast } from "vant";
import router from "../routes/router.js";
import tokenService from "@/services/tokenService.js";

const ajax = axios.create({
  baseURL: window.baseURL,
  timeout: 60000
});

ajax.interceptors.request.use(
  function(config) {
    let token = tokenService.getToken();
    if (token) {
      config.headers.common["Authorization"] = "Bearer " + token;
    }

    config.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

ajax.interceptors.response.use(
  respon => {
    if (respon.data.success !== true && respon.data.error) {
      showError(respon.data.error);
    }
    if (respon.data.unAuthorizedRequest === true) {
      router.push({
        name: "errorinfo",
        query: {
          retry: false,
          text: "登陆失败，请关闭页面后重试。"
        }
      });
    }

    return respon.data;
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push({
          name: "errorinfo",
          query: {
            retry: false,
            text: "登陆失败，请关闭页面后重试。"
          }
        });
      } else if (error.response.status === 403) {
        showError("无权进行此操作");
      } else if (
        !!error.response.data.error &&
        !!error.response.data.error.message &&
        error.response.data.error.details
      ) {
        showError(error.response.data.error.details);
      } else if (
        !!error.response.data.error &&
        !!error.response.data.error.message
      ) {
        showError(error.response.data.error.message);
      } else {
        showError(error.message);
      }
    } else if (
      error.code === "ECONNABORTED" ||
      error.message === "Network Error"
    ) {
      router.push({
        name: "errorinfo",
        query: {
          retry: router.currentRoute.name != "login",
          text: "网络访问失败，请稍后重试。"
        }
      });
    } else {
      showError(error.message);
    }

    return Promise.reject(error);
  }
);

function showError(message) {
  if (router.currentRoute.name == "login") {
    router.replace({
      name: "errorinfo",
      query: {
        retry: false,
        text: message
      }
    });
  } else {
    Toast(message);
  }
}

export default ajax;
